import { ApiService } from "../../../services/ApiService";
import { GET_REPORTING } from "../../actionTypes";

export class reportingThunk {
  static getReporting() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get("reporting");
        console.log("res", response);
        if (response.data) {
          dispatch({
            type: GET_REPORTING,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/reportingmanagement/reporting.thunk.js